<template>
  <LoaderComponent :value="promises.fetch" class="template-subpage" :data-slug="slug">
    <div v-if="cover" class="template-subpage__cover">
      <Slider :value="cover" :display-thumbnail="true" />
    </div>
    <div class="template-subpage__content" v-html="value.content"></div>
    <div class="template-subpage__actions g-1">
      <ButtonComponent
        :label="$t('goBack')"
        :icon="['far', 'arrow-left']"
        icon-placement="left"
        tag="router-link"
        :to="{ name: 'Project' }"
      />
    </div>
  </LoaderComponent>
</template>

<script>
import { mapState } from 'vuex'
import BrowserApiMixin from './mixins/browser-api'
import { LoaderComponent } from 'vue-elder-loader'
import { ButtonComponent } from 'vue-elder-button'
import Slider from '@kvass/media-render/Slider'

export default {
  mixins: [BrowserApiMixin('subpage')],
  props: {
    slug: String,
  },
  computed: {
    ...mapState('Root', ['item', 'promises']),
    cover() {
      return this.$path('value.images') || this.$path('value.media.cover')
    },
    value() {
      return (
        [
          ...(this.$path('item.customFields.subpages') || []),
          ...(this.$path('item.posts') || []),
        ].find(e => e.slug === this.slug) || {}
      )
    },
  },
  metaInfo() {
    return {
      title: this.$path('value.title') || '',
      link: [
        ...(this.value.images || []).map(item => ({
          rel: 'preload',
          as: 'image',
          href: item,
        })),
      ],
    }
  },
  components: {
    LoaderComponent,
    ButtonComponent,
    Slider,
  },
}
</script>

<style lang="scss">
.template-subpage {
  display: grid;
  grid-gap: 2rem;
  max-width: 800px;
  margin: 4rem auto;

  @include respond-below('phone') {
    margin: 0 auto 4rem;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 500ms;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  &__cover {
    aspect-ratio: 16 / 9;
  }

  &__content {
    font-size: 1.2em;
    line-height: 1.9;

    @include respond-below('phone') {
      padding: 0 2rem;
      font-size: 1em;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
